import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3v18h18","key":"svg-0"}],["path",{"d":"M3 6h18","key":"svg-1"}],["path",{"d":"M3 8c10 0 8 9 18 9","key":"svg-2"}]]

const IconChartSankey = createReactComponent('outline', 'chart-sankey', 'ChartSankey', __iconNode);

export default IconChartSankey;